// extracted by mini-css-extract-plugin
export default {"textContainer":"TextWithHint__textContainer--hhuKPcFydrhCZbm2uM9p","hint":"TextWithHint__hint--Di4iIxSdDXrx68GM9FY6"};